// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__z+7WX","modal":"Modal_modal__mOk4N"};